import {FormControlLabel,Switch} from "@mui/material"

const TransactionSwitch = ({isChecked,label,onChange}) => {

    return (
        <FormControlLabel control={<Switch checked={isChecked} onChange={(event) => {onChange(event.target.checked)}} />} label={label} />
    )
}

export default TransactionSwitch